import React, { FunctionComponent } from 'react';

import { EmptyProps, Empty as OrbEmpty } from '@yandex-360/orb-components/dist/components/Empty';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { isSafariBasedSelector } from '../../../../../../shared/features/uatraits';
import styles from './styles.css';

export const Empty: FunctionComponent<EmptyProps> = (props) => {
    const isSafariBased = useSelector(isSafariBasedSelector);
    return (
        <OrbEmpty {...props} className={cn(props.className, styles.empty, { [styles.isSafariBased]: isSafariBased })} />
    );
};
